<section class="w-full h-full bg-main-blue-light md:px-10 py-16 px-4">
  <div class="container mx-auto h-full w-full">
    <div class="flex flex-col items-center justify-center gap-4">
      <h2
        i18n="organizer.interest|Feel interest heading@@organizer.interest.title"
        class="text-3xl font-semibold text-white tracking-wide"
      >
        Feel Interest?
      </h2>
    </div>
    <div class="flex flex-col items-center justify-center gap-4 mt-2.5">
      <p
        i18n="organizer.interest|Interest subtitle@@organizer.interest.subtitle"
        class="text-white text-center tracking-wide font-thin"
      >
        Let's try the new solution for your business!
      </p>
    </div>
    <div class="flex flex-col items-center justify-center gap-4">
      <a
        class="bg-white text-main-blue-light md:w-fit w-full text-sm px-5 py-2.5 rounded-full flex items-center justify-center gap-2 cursor-pointer mt-10 hover:bg-main-yellow hover:text-white hover:border-0 transition-all duration-300 active:scale-95"
        href="https://lin.ee/qe4HGmS"
        target="_blank"
      >
        <span i18n="organizer.interest|Get in touch button@@organizer.interest.getInTouch">
          Get In Touch</span
        >
        <span>
          <img
            src="open_in_new_blue.svg"
            alt="Open in new tab"
            class="w-4 h-4 text-main-blue-light"
          />
        </span>
      </a>
    </div>
  </div>
</section>
